var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCabelo = function SvgCabelo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 61 58"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cabelo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__b)",
    d: "M13.2 14.32c.21.28.54.46.9.47l9.28.03h.01c.41 0 .79-.23.99-.59.86-1.59 3.65-6.93 3.64-8.73C28 2.79 25.8.59 23.09.6L5.15.67h-.04c-.08.01-.16.01-.23.03-.03 0-.05.02-.08.02l-.18.09c-.02.01-.03.01-.05.02L.55 3.24c-.35.21-.56.59-.55.99l.06 2.83c.01.39.22.75.56.95l3.99 2.31c.01.01.03.01.05.02.06.03.12.06.19.08.03.01.05.02.07.02.09.02.17.04.26.03l3.09-.02C1.99 23.56 2.79 24.02 3.79 24.59c.21.13.41.24.67.24.97 0 2.71-1.62 8.74-10.51M2.27 4.84l1.77-1.06.01 3.61L2.3 6.38zm8.82 4.96c.27-.56.04-1.23-.52-1.5-.22-.1-.45-.13-.67-.1-.05-.01-.09-.02-.14-.02l-3.46.03V6.69l11.65-.04c.62 0 1.13-.51 1.12-1.13 0-.62-.51-1.12-1.13-1.12l-11.65.04-.01-1.52 16.82-.06c1.46 0 2.66 1.18 2.66 2.64 0 .79-1.53 4.16-3.06 7.07l-7.85-.02c-.08-.19-.17-.42-.27-.67-.02-.05-.05-.09-.07-.13-.06-.27-.22-.52-.47-.69-.52-.35-1.22-.21-1.56.31-2.61 3.9-4.57 6.63-5.95 8.43.93-2.27 2.42-5.61 4.56-10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__c)",
    d: "m33.93 51.22-7.19-30.03a1.127 1.127 0 0 0-2.19.53l7.16 29.89a3.12 3.12 0 0 1-3.11 3.01l-19.02.06a3.127 3.127 0 0 1-3.13-2.99l6.95-29.94c.02-.08.03-.17.03-.26a3.12 3.12 0 0 1 3.11-3.13l4.84-.02c.36 0 .71.06 1.04.17.59.21 1.23-.1 1.44-.69s-.1-1.23-.69-1.44c-.58-.2-1.18-.3-1.79-.3l-4.85.02c-2.92.01-5.29 2.36-5.36 5.26L4.23 51.32c-.02.08-.03.17-.03.26a5.38 5.38 0 0 0 5.39 5.36l19.01-.07a5.38 5.38 0 0 0 5.36-5.4c0-.08-.01-.17-.03-.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__d)",
    d: "M37.98 55.52c-.2.2-.49.33-.8.33-.62 0-1.13-.51-1.12-1.13l.15-49.35C36.22 1.29 39.98.08 41.96 0l17.4.18c.62.01 1.12.52 1.12 1.14-.01.62-.52 1.12-1.14 1.11L42 2.25c-.31.01-3.53.24-3.54 3.12l-.14 49.35c0 .32-.13.6-.34.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__e)",
    d: "M59.99 57.1c-.21.2-.49.33-.8.33l-15.23-.04c-.27.01-1.28-.03-2.13-.82q-1.11-1.05-1.11-3.06l.14-48.52 2.26.01-.14 48.52c0 .66.13 1.14.38 1.4.23.23.53.23.54.23l15.3.04c.62 0 1.12.51 1.12 1.13 0 .3-.13.58-.33.78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__f)",
    d: "M60 52.69c-.21.2-.49.33-.8.33l-13.8-.04c-.62 0-1.13-.51-1.12-1.13 0-.62.51-1.12 1.13-1.12l13.8.04a1.127 1.127 0 0 1 .79 1.92"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__g)",
    d: "M60.01 47.51c-.2.2-.48.33-.8.33l-13.8-.04c-.62 0-1.12-.51-1.12-1.13s.51-1.13 1.13-1.13l13.8.04c.62 0 1.12.51 1.12 1.13 0 .31-.12.59-.33.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__h)",
    d: "M60.03 42.32c-.21.2-.49.33-.8.33l-13.8-.04c-.62 0-1.13-.51-1.12-1.13 0-.62.51-1.13 1.13-1.12l13.8.04c.62 0 1.13.51 1.12 1.13 0 .3-.13.58-.33.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__i)",
    d: "M60.04 37.13c-.21.2-.49.33-.8.33l-13.8-.04c-.62 0-1.12-.51-1.12-1.13s.51-1.12 1.13-1.12l13.8.04c.62 0 1.12.51 1.12 1.13 0 .31-.12.59-.33.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__j)",
    d: "M60.06 31.94c-.21.2-.49.33-.8.33l-13.8-.04c-.62 0-1.12-.51-1.12-1.13s.51-1.12 1.13-1.12l13.8.04c.62 0 1.13.51 1.12 1.13 0 .31-.13.59-.33.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__k)",
    d: "M60.07 26.76c-.2.2-.49.33-.8.33l-13.8-.04c-.62 0-1.12-.51-1.12-1.13s.51-1.12 1.13-1.12l13.8.04c.62 0 1.13.51 1.12 1.13 0 .3-.12.59-.33.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__l)",
    d: "M60.09 21.57c-.2.2-.49.33-.8.33l-13.8-.04c-.62 0-1.13-.51-1.12-1.13 0-.62.51-1.12 1.13-1.12l13.8.04a1.127 1.127 0 0 1 .79 1.92"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__m)",
    d: "M60.1 16.38c-.21.2-.49.33-.8.33l-13.8-.04c-.62 0-1.12-.51-1.12-1.13s.51-1.13 1.13-1.12l13.8.04c.62 0 1.13.51 1.12 1.13 0 .31-.12.59-.33.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__n)",
    d: "M60.12 11.2c-.2.2-.48.33-.8.33l-13.8-.04c-.62 0-1.12-.51-1.12-1.13s.51-1.12 1.13-1.12l13.8.04c.62 0 1.13.51 1.12 1.13 0 .3-.13.58-.33.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cabelo_svg__o)",
    d: "M60.13 6.01c-.2.2-.48.33-.8.33l-13.8-.04c-.62 0-1.12-.51-1.12-1.13s.51-1.13 1.13-1.12l13.8.04c.62 0 1.13.51 1.12 1.13.01.31-.12.59-.33.79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__b",
    x1: 0,
    x2: 28.608,
    y1: 24.83,
    y2: 24.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__c",
    x1: 4.2,
    x2: 34.596,
    y1: 56.94,
    y2: 56.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__d",
    x1: 36.06,
    x2: 61.006,
    y1: 55.85,
    y2: 55.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__e",
    x1: 40.72,
    x2: 60.742,
    y1: 57.43,
    y2: 57.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__f",
    x1: 44.28,
    x2: 60.309,
    y1: 53.02,
    y2: 50.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__g",
    x1: 44.29,
    x2: 60.322,
    y1: 47.84,
    y2: 45.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__h",
    x1: 44.31,
    x2: 60.339,
    y1: 42.65,
    y2: 40.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__i",
    x1: 44.32,
    x2: 60.349,
    y1: 37.46,
    y2: 35.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__j",
    x1: 44.34,
    x2: 60.369,
    y1: 32.27,
    y2: 29.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__k",
    x1: 44.35,
    x2: 60.379,
    y1: 27.09,
    y2: 24.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__l",
    x1: 44.37,
    x2: 60.399,
    y1: 21.9,
    y2: 19.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__m",
    x1: 44.38,
    x2: 60.409,
    y1: 16.71,
    y2: 14.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__n",
    x1: 44.4,
    x2: 60.429,
    y1: 11.53,
    y2: 9.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cabelo_svg__o",
    x1: 44.41,
    x2: 60.439,
    y1: 6.34,
    y2: 3.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA9261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786A47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cabelo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60.48v57.43H0z"
  })))));
};
export default SvgCabelo;